import type { ReactNode } from 'react';

export function Switch({
  checked = false,
  onChange,
  label,
}: {
  checked?: boolean;
  onChange?: (next: boolean) => void;
  label?: ReactNode;
}) {
  return (
    <label
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 12,
        cursor: 'pointer',
        fontFamily: 'var(--font-vi)',
        fontSize: 14,
        color: 'var(--ink)',
      }}
    >
      {label && <span>{label}</span>}
      <span
        onClick={() => onChange?.(!checked)}
        style={{
          width: 44,
          height: 26,
          borderRadius: 999,
          position: 'relative',
          flexShrink: 0,
          background: checked ? 'var(--cta-default)' : 'var(--border-default)',
          transition: 'background 0.15s',
        }}
      >
        <span
          style={{
            position: 'absolute',
            top: 3,
            left: checked ? 21 : 3,
            width: 20,
            height: 20,
            borderRadius: '50%',
            background: '#fff',
            boxShadow: '0 1px 3px rgba(0,0,0,0.25)',
            transition: 'left 0.15s',
          }}
        />
      </span>
    </label>
  );
}
